import React from 'react';
import GeneralRateRow from '../pricing/general-rate-row';

function PricingTotalCard(props) {
    const { title, rowLabel, total } = props;
    return (
        <div className='item-card-container'>
            <div className='main-card flex-size-full'>
                <label className='general-card-name'>{title}</label>
                <GeneralRateRow
                    title={rowLabel}
                    total={total}
                    contClasses="card-value-container general-total bg-input"
                />
            </div>
        </div>
    )
}

export default PricingTotalCard